module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    class: _vm.column.class + [(parseInt(_vm.column.colspan) === 1 && _vm.sortDisp) ? ' cursor-pointer' : ''],
    style: (_vm.column.style),
    attrs: {
      "name": "sort-column",
      "colspan": _vm.column.colspan,
      "rowspan": _vm.column.rowspan
    },
    on: {
      "click": function($event) {
        _vm.setSortProperty(_vm.column.key, _vm.column.colspan)
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.column.name) + "\n  "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.column.colspan) === 1 && _vm.sortDisp),
      expression: "parseInt(column.colspan) === 1 && sortDisp"
    }],
    class: 'fa fa-' + _vm.sortType
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3da2b3bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsTableTemplate/sortColumn.vue
// module id = 3705
// module chunks = 1